module.exports = __webpack_public_path__ + "img/icon-category.51e21179.svg";